import { render, staticRenderFns } from "./TermsView.vue?vue&type=template&id=ca6c0c24&scoped=true"
import script from "./TermsView.vue?vue&type=script&lang=js"
export * from "./TermsView.vue?vue&type=script&lang=js"
import style0 from "./TermsView.vue?vue&type=style&index=0&id=ca6c0c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6c0c24",
  null
  
)

export default component.exports